(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root = document) {
    root.querySelectorAll('[data-success-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.dataset.motionVersion = '11';
      const track = gallery.querySelector('.tn-success__track');
      const cards = [...track.querySelectorAll('.tn-success__card')];
      if (!cards.length) return;
      const previous = gallery.querySelector('[data-prev]'), next = gallery.querySelector('[data-next]');
      const count = gallery.querySelector('.tn-success__count'), progress = gallery.querySelector('.tn-success__progress span');
      // Automatic changes never repeatedly announce themselves to screen readers.
      count.setAttribute('aria-live','off');
      const toggle = document.createElement('button');
      toggle.type = 'button'; toggle.dataset.autoplay = '';
      gallery.querySelector('.tn-success__controls').prepend(toggle);
      let pages = [], current = 0, timer = 0, frame = 0, visible = false, hover = false, focus = false, touching = false;
      let paused = false, width = 0, moving = false, disposed = false;
      let keyboard = false;
      const events = [];
      const log = event => {events.push({event,page:current+1,at:Math.round(performance.now())});if(events.length>80)events.shift();gallery.dataset.motionLog=JSON.stringify(events);};
      const step = () => track.clientWidth + (parseFloat(getComputedStyle(track).columnGap)||28);
      function state() {
        toggle.textContent = paused ? '▷' : 'Ⅱ';
        toggle.setAttribute('aria-label',paused?'Play success stories':'Pause success stories');
        toggle.setAttribute('aria-pressed',String(paused));
        const reasons=[paused&&'user',reduced.matches&&'reduced-motion',!visible&&'offscreen',document.hidden&&'hidden',hover&&'reading-card',focus&&'keyboard-focus',touching&&'touch'].filter(Boolean).join(',');
        if(gallery.dataset.pauseReason!==reasons){gallery.dataset.pauseReason=reasons;log('state:'+ (reasons||'playing'));}
        gallery.dataset.autoplay = String(!reasons);
        toggle.title=paused?'Resume automatic stories':reasons?'Temporarily paused: '+reasons:'Pause automatic stories';
        gallery.classList.toggle('is-motion-paused',gallery.dataset.autoplay!=='true');
      }
      function schedule() {
        clearTimeout(timer);state();
        if (!disposed && gallery.dataset.autoplay==='true' && pages.length>1 && !moving) timer=setTimeout(()=>move(1),3200);
      }
      function status(index) {
        current = Math.max(0,Math.min(pages.length-1,index));
        count.textContent = `${current+1} / ${pages.length}`;
        previous.disabled = next.disabled = pages.length<2;
        progress.style.width = `${100/pages.length}%`;
        progress.style.transform = `translateX(${current*100}%)`;
        gallery.dataset.page=String(current+1);
      }
      function cancel() {cancelAnimationFrame(frame);frame=0;moving=false;track.classList.remove('is-moving');}
      function settle() {
        cancel();
        let index=Math.round(track.scrollLeft/step());
        if(index>=pages.length){track.scrollLeft=0;index=0;}
        status(index);schedule();
      }
      function move(delta) {
        clearTimeout(timer);cancel();
        const target=(current+delta+pages.length)%pages.length;
        // A noninteractive copy of page one lets the last page glide forward seamlessly.
        const wrap=delta>0 && current===pages.length-1;
        const from=track.scrollLeft,to=(wrap?pages.length:target)*step();
        if(reduced.matches || (delta<0 && current===0)){track.scrollLeft=target*step();status(target);schedule();return;}
        moving=true;track.classList.add('is-moving');
        const start=performance.now();
        function tick(now){
          const p=Math.min(1,(now-start)/760),e=p*p*p*(p*(p*6-15)+10);
          track.scrollLeft=from+(to-from)*e;
          if(p<1){frame=requestAnimationFrame(tick);return;}
          if(wrap)track.scrollLeft=0;
          cancel();status(target);log(wrap?'loop':'advance');schedule();
        }
        frame=requestAnimationFrame(tick);
      }
      function layout() {
        cancel();clearTimeout(timer);
        const size=gallery.clientWidth>=990?8:gallery.clientWidth>=600?6:gallery.clientWidth>=320?4:2;
        const firstCard=current*(Number(gallery.dataset.pageSize)||size);
        track.replaceChildren();pages=[];
        for(let i=0;i<cards.length;i+=size){const page=document.createElement('div');page.className='tn-success__page';cards.slice(i,i+size).forEach(card=>page.append(card));track.append(page);pages.push(page);}
        if(pages.length>1){const clone=pages[0].cloneNode(true);clone.inert=true;clone.setAttribute('aria-hidden','true');clone.dataset.loopCopy='';clone.querySelectorAll('a').forEach(a=>a.tabIndex=-1);track.append(clone);}
        gallery.classList.remove('is-pinned');gallery.style.height='auto';gallery.dataset.pageSize=String(size);
        status(Math.min(pages.length-1,Math.floor(firstCard/size)));track.scrollLeft=current*step();width=gallery.clientWidth;schedule();
      }
      previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      toggle.addEventListener('click',()=>{paused=!paused;if(paused&&moving){cancel();track.scrollLeft=current*step();}if(!paused){hover=false;focus=false;touching=false;}log(paused?'pause':'play');schedule();});
      // Pause only over a story being read, not blank space or navigation controls.
      track.addEventListener('pointerover',e=>{if(e.pointerType==='mouse'){hover=!!e.target.closest('.tn-success__card');schedule();}});
      track.addEventListener('pointerleave',()=>{hover=false;schedule();});
      gallery.addEventListener('pointerdown',()=>{keyboard=false;focus=false;schedule();},{passive:true});
      const onKey=()=>{keyboard=true;focus=track.contains(document.activeElement);schedule();};
      document.addEventListener('keydown',onKey);
      gallery.addEventListener('focusin',()=>{focus=keyboard&&track.contains(document.activeElement);schedule();});
      gallery.addEventListener('focusout',()=>queueMicrotask(()=>{focus=keyboard&&track.contains(document.activeElement);schedule();}));
      track.addEventListener('pointerdown',()=>{touching=true;cancel();schedule();},{passive:true});
      const release=()=>{if(touching){touching=false;settle();}};
      window.addEventListener('pointerup',release,{passive:true});window.addEventListener('pointercancel',release,{passive:true});
      let scrollTimer;
      track.addEventListener('scroll',()=>{if(!moving){clearTimeout(scrollTimer);scrollTimer=setTimeout(settle,140);}},{passive:true});
      track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
      track.addEventListener('focusin',event=>{const index=pages.findIndex(page=>page.contains(event.target));if(index>=0&&index!==current){cancel();track.scrollLeft=index*step();status(index);}});
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(!visible){hover=false;touching=false;if(moving){cancel();track.scrollLeft=current*step();}}schedule();},{threshold:.25});
      observer.observe(track);
      const resize=new ResizeObserver(()=>{if(Math.abs(gallery.clientWidth-width)>1)layout();});resize.observe(gallery);
      const visibility=()=>{if(document.hidden){touching=false;hover=false;if(moving){cancel();track.scrollLeft=current*step();}}schedule();};
      document.addEventListener('visibilitychange',visibility);
      const preference=()=>{if(reduced.matches){cancel();track.scrollLeft=current*step();}schedule();};
      reduced.addEventListener('change',preference);
      const resume=()=>{touching=false;hover=false;focus=keyboard&&track.contains(document.activeElement);cancel();track.scrollLeft=current*step();schedule();log('resume');};
      window.addEventListener('pageshow',resume);window.addEventListener('blur',release);

      gallery.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{disposed=true;document.removeEventListener('keydown',onKey);window.removeEventListener('pageshow',resume);window.removeEventListener('blur',release);cancel();clearTimeout(timer);clearTimeout(scrollTimer);observer.disconnect();resize.disconnect();document.removeEventListener('visibilitychange',visibility);reduced.removeEventListener('change',preference);window.removeEventListener('pointerup',release);window.removeEventListener('pointercancel',release);});
      layout();log('ready');
    });
    if(root===document && document.querySelector('.tn-engineering')){
      // Shared 6.4s breath with short double pulses; phase offsets avoid lockstep.
      const selector='.tn-engineering .hero-copy > *, .tn-engineering .motion-dock, .tn-engineering .hero-actions a, #technast-services .rte img, #technast-services h3, #technast-services .page-title, .tn-success__image img, .tn-success__top h2, .tn-success__controls button, .tn-success__all, .header__heading-logo, .header__icon svg, .header__menu-item span, .footer h2, .footer .list-social svg, .footer .list-payment svg, [id*="177765034081609e5b"] img';
      const elements=[...document.querySelectorAll(selector)];
      const observer=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>target.classList.toggle('is-motion-visible',isIntersecting)),{threshold:0});
      elements.forEach((el,i)=>{
        el.classList.add('tn-ambient');
        const pulse=el.matches('img,svg,button,.hero-actions a,.tn-success__all');
        el.classList.add(pulse?'tn-pulse':'tn-breathe');
        el.style.setProperty('--motion-phase',`${-(i%8)*.4}s`);
        observer.observe(el);
      });
      const visibility=()=>document.documentElement.classList.toggle('tn-motion-hidden',document.hidden);
      document.addEventListener('visibilitychange',visibility);visibility();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
